module.exports = {
	"_args": [
		[
			"traceur@https://registry.npmjs.org/traceur/-/traceur-0.0.102.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "traceur@0.0.102",
	"_id": "traceur@0.0.102",
	"_inCache": true,
	"_location": "/traceur",
	"_phantomChildren": {
		"inflight": "1.0.4",
		"inherits": "2.0.1",
		"minimatch": "2.0.10",
		"once": "1.3.3"
	},
	"_requested": {
		"name": "traceur",
		"raw": "traceur@https://registry.npmjs.org/traceur/-/traceur-0.0.102.tgz",
		"rawSpec": "https://registry.npmjs.org/traceur/-/traceur-0.0.102.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/traceur/-/traceur-0.0.102.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/traceur/-/traceur-0.0.102.tgz",
	"_shasum": "cdcd98419ceac31453b9066f4fa3aa972c206f6e",
	"_shrinkwrap": null,
	"_spec": "traceur@https://registry.npmjs.org/traceur/-/traceur-0.0.102.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"name": "Traceur Authors"
	},
	"bin": {
		"traceur": "./traceur"
	},
	"bugs": {
		"url": "https://github.com/google/traceur-compiler/issues"
	},
	"dependencies": {
		"commander": "2.6",
		"glob": "4.3",
		"rsvp": "^3.0.13",
		"semver": "4.3.2",
		"source-map-support": "~0.2.8"
	},
	"description": "ES6 to ES5 compiler",
	"devDependencies": {
		"chai": "2.2.x",
		"express": "4.x",
		"mocha": "2.2.x",
		"node-uuid": "1.x",
		"promises-aplus-tests": "2.x",
		"regenerate": "1.2.1",
		"regexpu": "1.1.0",
		"regjsgen": "0.2.0",
		"regjsparser": "0.1.5",
		"requirejs": "2.x",
		"serve-index": "1.x",
		"source-map": "0.1.43",
		"traceur": "0.0.101",
		"webcomponents.js": "^0.5.4-1"
	},
	"engines": {
		"node": ">=0.10"
	},
	"files": [
		"bin/traceur-runtime.js",
		"bin/traceur.js",
		"dist/",
		"src/",
		"traceur"
	],
	"homepage": "https://github.com/google/traceur-compiler",
	"keywords": [
		"ES.next",
		"compiler",
		"ecmascript",
		"es5",
		"es6",
		"harmony",
		"javascript",
		"language",
		"transpiler"
	],
	"license": "Apache-2.0",
	"main": "./src/node/api.js",
	"name": "traceur",
	"optionalDependencies": {},
	"readme": "[![Join the chat at https://gitter.im/google/traceur-compiler](https://badges.gitter.im/Join%20Chat.svg)](https://gitter.im/google/traceur-compiler?utm_source=badge&utm_medium=badge&utm_campaign=pr-badge&utm_content=badge)\n[![Build Status](https://travis-ci.org/google/traceur-compiler.svg)](https://travis-ci.org/google/traceur-compiler)\n\n<img src=\"https://google.github.com/traceur-compiler/logo/tc.svg\" alt=\"Traceur logo\" width=\"200px\">\n\n## What is Traceur?\n\nTraceur is a JavaScript.next-to-JavaScript-of-today compiler that allows you to\nuse features from the future **today**. Traceur supports ES6 as well as some experimental ES.next features.\n\nTraceur's goal is to inform the design\nof new JavaScript features which are only valuable if they allow you to write\nbetter code. Traceur allows you to try out new and proposed\n[language features](https://github.com/google/traceur-compiler/wiki/LanguageFeatures)\ntoday, helping you say what you mean in your code while informing the standards process.\n\nJavaScript's evolution needs your input.\n[Try](https://github.com/google/traceur-compiler/wiki/Getting-Started) out the\nnew language features.\n[Tell us](http://groups.google.com/group/traceur-compiler-discuss)\nhow they work for you and what's still causing you to use more boilerplate and\n\"design patterns\" than you prefer.\n\n## What now? What can Traceur do for me?\n\nRead the\n[Getting Started](https://github.com/google/traceur-compiler/wiki/Getting-Started)\npage to get up and running. You can use some language features right now and\neven try it out in your browser\n[here](https://google.github.io/traceur-compiler/demo/repl.html).\nJust type in some code and see what Traceur produces. For an idea of what is\navailable and what we have in the pipeline, see the\n[Language Features](https://github.com/google/traceur-compiler/wiki/LanguageFeatures)\npage.\n\nThe JSConf 2011 presentation of Traceur describes the goals of the project and\nwhat it can do today. Some documentation is on the wiki on this site.\nExtra demos are in the source repository.\n\nWe also presented Traceur at NodeConf 2011. The video is\navailable on [YouTube](http://www.youtube.com/watch?feature=player_detailpage&v=ntDZa7ekFEA).\n\nQuestions, suggestions, and comments can be directed to the\n[discussion group](http://groups.google.com/group/traceur-compiler-discuss).\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/google/traceur-compiler.git"
	},
	"scripts": {
		"/** Update Version Number **/": "After publishing version N, update the version number and commit the result",
		"/** Update gh-pages branch **/": "Ater publishing version N, update the github docs and REPL",
		"checkout-gh-pages": "git checkout -b upstream_gh_pages upstream/master",
		"checkout-upstream": "git checkout -b upstream_master upstream/master",
		"commit-gh-pages": "git add -- src/ bin/ && ./traceur -v | xargs -I VERSION git commit -a -m \"Commit binaries for VERSION\"",
		"commit-published": "cat build/npm-version-number | xargs -I VERSION git commit -a -m \"VERSION\"",
		"just-publish": "npm publish # workaround https://github.com/npm/npm/issues/10074 ",
		"postjust-publish": "npm run push-published && npm run push-gh-pages",
		"postpush-gh-pages": "git checkout master && git branch -D upstream_gh_pages",
		"postpush-published": "git checkout master && git branch -D upstream_master",
		"precheckout-gh-pages": "git branch -D upstream_gh_pages || true",
		"precheckout-upstream": "git fetch upstream && git branch -D upstream_master || true",
		"precommit-gh-pages": "npm run checkout-gh-pages && npm run rebuild && cp gh-pages.gitignore .gitignore # tell git to commit built files.",
		"precommit-published": "npm run update-semver && npm run rebuild",
		"prejust-publish": "npm run checkout-upstream && npm run rebuild",
		"prepush-gh-pages": "npm run commit-gh-pages",
		"prepush-published": "npm run commit-published && npm run tag-published",
		"push-gh-pages": "git push -f upstream upstream_gh_pages:gh-pages",
		"push-published": "git push --tags upstream upstream_master:master && git push upstream upstream_master:master  # Push source for version N+1",
		"rebuild": "make clean && make dist/commonjs && make test",
		"start": "make && node ./demo/expressServer.js",
		"store-semver": "node build/versionInfo.js -v > build/npm-version-number",
		"tag-published": "cat build/npm-version-number | xargs -I VERSION git tag -a VERSION -m \"Tagged version VERSION \"",
		"test": "make test",
		"update-semver": "npm run store-semver && git diff --quiet -- package.json && node build/versionInfo.js -n"
	},
	"subdomain": "traceur",
	"version": "0.0.102"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/traceur/package.json
 ** module id = ./node_modules/traceur/package.json
 ** module chunks = 0
 **/